import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { ASSET_CLASS_URL, ASSET_CLASS_DOWNLOAD_URL } from "../../Constants/Constants";

import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import AddTaskIcon from "@mui/icons-material/AddTask";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useAlert } from "./../alerts/AlertContext";
import { Link } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { isEmpty } from "../../Constants/RolesConstants";

function AssetClassDialog({
  assetClassId,
  selectedClassName,
  callAssetClasses,
  actionType,
  isEdit,
  componentPermissions = {},
}) {
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const [open, setOpen] = React.useState(false);
  const [className, setClassName] = useState("");
  const [desc, setDesc] = useState("");
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState(true);
  const showAlert = useAlert();

  const [fileName, setFileName] = useState();
  const [extension, setExtension] = useState();


  const handleClickOpen = () => {

    if (isEdit === true) {
      getAssetClass();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClassNameChange = (event) => {
    setClassName(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const handleFileChange = (e) => {

    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleDownload = async (attachId, attachFileName, fileExt) => {
    try {
      const response = await AxiosInstance.get(`${ASSET_CLASS_DOWNLOAD_URL}/${attachId}`, {
        responseType: "blob",
      });

      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: fileExt })
      );

      const alink = document.createElement("a");
      alink.href = fileURL;
      alink.setAttribute("download", attachFileName);
      document.body.appendChild(alink);
      alink.click();
      alink.parentNode.removeChild(alink);

      // setNotification({
      //     open: true,
      //     message: 'File downloaded successfully',
      //     severity: 'success'
      // });
    } catch (error) {
      // setNotification({
      //     open: true,
      //     message: 'Failed to download file',
      //     severity: 'error'
      // });
      console.error('Error downloading file:', error);
    }
  };

  const saveButtonSx = {
    float: "right",
    minWidth: 150,
    marginRight: "25px",
    marginTop: "10px",
    background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
    boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
    "&:hover": {
      background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
    },
  };

  const getAssetClass = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(`${ASSET_CLASS_URL}/${assetClassId}`).then((response) => {
      //setData(response.data)
      var classData = response.data.data;
      setClassName(classData.name);
      setDesc(classData.description);
      setStatus(classData.status);
      setOpen(true);
      setFileName(classData.fileName);
      setExtension(classData.extension);
    }
    )
  };

  const handleSave = () => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", className);
    formData.append("description", desc);
    formData.append("status", status);
    if (isEdit) {
      //formData.append("id", assetClassId);
      updateAssetClass(formData);
    } else {
      saveAssetClass(formData);
    }
  };

  const saveAssetClass = async (formData) => {
    await AxiosInstance.post(ASSET_CLASS_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then((response) => {
        showAlert("Asset Class created successfully!", "success");
        callAssetClasses();
      })
      .catch((error) => {
        showAlert("Asset Class creation failed!", "error");
        console.error(error);
      });
  };

  const updateAssetClass = async (formData) => {
    await AxiosInstance.put(`${ASSET_CLASS_URL}/${assetClassId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then((response) => {
        showAlert("Asset Class updated successfully!", "success");
        callAssetClasses();
      })
      .catch((error) => {
        showAlert("Asset Class updation failed!", "error");
        console.error(error);
      });
  };
  return (
    <ThemeProvider>
      <React.Fragment>
        {/* <Button
          variant="outlined"
          onClick={handleClickOpen}
          style={{ float: "right", margin: "5px 0px" }}
        >
          Add Asset Class
        </Button> */}
        {assetClassId === 0 ? (
          <Tooltip
            title="Add Asset Class"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px", float: "right" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
        ) : (
            <Link onClick={handleClickOpen}>{selectedClassName}</Link>
          )}

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              (isEmpty(componentPermissions) ||
                componentPermissions?.["canUpdate"] ||
                componentPermissions?.["canCreate"]) &&
                handleSave();
              handleClose();
            },
            sx: {
              width: 600,
              height: 500,
              maxWidth: "100%",
              maxHeight: "100%",
            },
          }}
        >
          <DialogTitle>{actionType} Asset Class</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="rg"
                name="name"
                label="Class Name"
                type="text"
                fullWidth
                variant="outlined"
                value={className}
                onChange={handleClassNameChange}
              />
              <br />
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={desc}
                onChange={handleDescriptionChange}
              />
              <br />

              <FormControl sx={{ m: 1, minWidth: "40%" }}>
                <FormLabel id="asset-class-status-label">
                  Status
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="asset-class-status-label"
                  name="row-radio-buttons-group"
                  value={status}
                  onChange={handleStatusChange}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Active"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="In-Active"
                  />
                </RadioGroup>
              </FormControl>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, m:1 }}>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
              >
                Upload files
                <VisuallyHiddenInput type="file" onChange={handleFileChange} />
              </Button>

              {assetClassId !== 0 && fileName != null && fileName != "" &&
              <>
                <br /> <br />
                <Link
                  underline="hover"
                  color="primary"
                  onClick={() => handleDownload(assetClassId, fileName, extension)}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <DownloadIcon fontSize="small" />
                  {fileName}
                </Link>
                </>
              }
              </Box>
              </Box>
          </DialogContent>
          <DialogActions sx={{ marginBottom: "20px" }}>
            {actionType === "Add" ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
            {actionType === "Edit" &&
            (isEmpty(componentPermissions) ||
              componentPermissions?.["canUpdate"]) ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default AssetClassDialog;
